// extracted by mini-css-extract-plugin
export default {"toolbar":"CustomToolbar_toolbar__VcOlA","year":"CustomToolbar_year__OdTkl","date":"CustomToolbar_date__zp2Gz","day":"CustomToolbar_day__AKgWz"};